import React from 'react';
import { Sparkles, Heart, Star } from 'lucide-react';

export default function Header() {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-primary-100 via-secondary-50 to-primary-50">
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 text-secondary-300 animate-pulse">
        <Sparkles className="w-8 h-8" />
      </div>
      <div className="absolute top-40 right-20 text-primary-300 animate-bounce" style={{ animationDelay: '1s' }}>
        <Heart className="w-6 h-6" />
      </div>
      <div className="absolute bottom-40 left-20 text-secondary-400 animate-pulse" style={{ animationDelay: '2s' }}>
        <Star className="w-5 h-5" />
      </div>
      
      <nav className="container mx-auto px-6 py-4 relative z-20">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative">
              <img
                src="/wezen-logo.png"
                alt="WeZen Logo"
                className="w-10 h-10 rounded-lg object-cover shadow-lg"
              />
              <div className="absolute -inset-1 bg-gradient-to-r from-primary-400 to-secondary-400 rounded-lg blur opacity-30"></div>
            </div>
            <a href="/" className="text-2xl font-bold bg-gradient-to-r from-primary-800 to-secondary-700 bg-clip-text text-transparent">WeZen</a>
          </div>
          {/* Navigation links */}
          <div className="flex items-center gap-4">
            <a
              href="/entreprise"
              className="px-5 py-2 rounded-full bg-primary-500 text-white font-semibold shadow hover:bg-primary-600 transition-colors border border-primary-500 hover:border-primary-600"
            >
              Entreprise
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
